import { render, staticRenderFns } from "./projectNotice.vue?vue&type=template&id=005459c4&scoped=true&"
import script from "./projectNotice.vue?vue&type=script&lang=js&"
export * from "./projectNotice.vue?vue&type=script&lang=js&"
import style0 from "./projectNotice.vue?vue&type=style&index=0&id=005459c4&prod&lang=scss&scoped=true&"
import style1 from "./projectNotice.vue?vue&type=style&index=1&id=005459c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005459c4",
  null
  
)

export default component.exports